import React, { useMemo } from "react"; // Nhớ import useMemo
import { Layers, Zap } from "lucide-react";
import SegmentBar from './SegmentBar';
import { SEGMENT_CONFIG } from '../../../../utils/data';

const SegmentSection = ({
  segmentStats,
  totalMerchants,
  selectedSegmentId,
  onSelectSegment,
}) => {
  
  // --- LOGIC TÌM NHÓM LỚN NHẤT ---
  const dominantSegment = useMemo(() => {
    // 1. Nếu không có dữ liệu thì trả về null
    if (!totalMerchants || totalMerchants === 0) return null;

    // 2. Tìm segment có count cao nhất
    let maxSegment = null;
    let maxCount = -1;

    SEGMENT_CONFIG.forEach((config) => {
      const count = segmentStats[config.id] || 0;
      if (count > maxCount) {
        maxCount = count;
        maxSegment = { ...config, count }; // Lưu lại cả config lẫn count
      }
    });

    // 3. Tính phần trăm
    const percentage = ((maxCount / totalMerchants) * 100).toFixed(1);

    return { ...maxSegment, percentage };
  }, [segmentStats, totalMerchants]);

  return (
    <section className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-sm font-bold text-slate-500 uppercase tracking-wider flex items-center gap-2">
          <Layers size={16} /> Phân nhóm Merchant (Theo số lượng)
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {SEGMENT_CONFIG.map((config) => (
          <SegmentBar
            key={config.id}
            config={config}
            count={segmentStats[config.id] || 0}
            totalCount={totalMerchants}
            isActive={selectedSegmentId === config.id}
            onClick={(c) => onSelectSegment(c.id)}
          />
        ))}
      </div>

      {/* Hiển thị Insight động */}
      <div className="bg-slate-100 rounded-lg p-4 text-sm text-slate-600 border border-slate-200 flex items-start gap-2">
        <Zap className="text-yellow-500 mt-0.5 flex-shrink-0" size={16} />
        <p>
          <span className="font-bold text-slate-800">Insight phân bổ: </span>
          {dominantSegment ? (
            <>
              Nhóm{" "}
              <span className={`font-bold ${dominantSegment.color.replace("bg-", "text-blue")}`}>
                {dominantSegment.label}
              </span>{" "}
              chiếm tỷ trọng lớn nhất (
              <span className="font-bold text-slate-600">{dominantSegment.percentage}%</span>
              ).
            </>
          ) : (
            <span>Chưa có đủ dữ liệu để phân tích.</span>
          )}
        </p>
      </div>
    </section>
  );
};

export default SegmentSection;